import { Stack } from '@mui/material';
import { useId } from 'react';

import { FormField } from 'common';

import {
  type CommunicationWindow,
  CommunicationWindowTimeRange,
  type TimeRangeValue,
} from './TimeRange';
import { WeekDaysSelector } from '../../../../../../../../components/WeekDaysSelector/WeekDaysSelector';

interface CommunicationWindowScheduleProps {
  communicationWindow?: CommunicationWindow;
  disabled?: boolean;
  onUpdate: (communicationWindow: Partial<CommunicationWindow>) => void;
}

export function CommunicationWindowSchedule(props: CommunicationWindowScheduleProps) {
  const { communicationWindow, disabled, onUpdate } = props;
  const daysFieldId = useId();
  const timeFieldId = useId();

  return (
    <Stack spacing={3}>
      <FormField id={daysFieldId} label="Allowed Days of the Week">
        <WeekDaysSelector
          selectedDays={communicationWindow?.daysOfWeek || []}
          onChange={(daysOfWeek) => {
            onUpdate({ ...communicationWindow, daysOfWeek });
          }}
          disabled={disabled}
        />
      </FormField>

      <FormField id={timeFieldId} label="Allowed Times of Day">
        <CommunicationWindowTimeRange
          times={communicationWindow}
          disabled={disabled}
          onTimeRangeChange={(timeRange: TimeRangeValue) =>
            onUpdate({ ...communicationWindow, timeRange })
          }
        />
      </FormField>
    </Stack>
  );
}
